module.exports = __webpack_public_path__ + "img/icons8-watch-96.38a2e0b0.png";